<template>
  <div class="container"  >
    <div class="userpage_portfolio_tags_list">
    <ul class="nav mt-5 userpage_portfolio_tags_list mb-2 col-12 d-flex justify-content-center mx-auto" v-if="tags.length>0">
      <li class="nav-item " v-for="(tag,tag_index) in tags" :key="tag_index">
        <button class="nav-link btn ml-2 mr-2 mb-1" @click="openTag(tag.tag)" :class='{"tag_active":(active_tag==tag.tag),"tag_not_active":!(active_tag==tag.tag)}' href="#">{{ tag.title}}</button>
      </li>

    </ul>
    </div>
    <div class="row"  v-if="chunks_works && chunks_works.length>0" v-for="(chunk,chunk_index) in chunks_works" :key="chunk_index">
      <div class="col-12 col-md-4" v-if="chunk.length>0 && ((active_tag=='all' || work.tags.tags.includes(active_tag)))" v-for="(work,work_index) in chunk" :key="work_index">
        <router-link  tag="a"
            :to="{name: 'user_page_one_portfolio', params: { user_id: work.user_id,work_id:work.last_id }}"><div class="userpage-img-container">
          <v-lazy-image :src="work.image" class="userpage-img-fit"/>
          <div class="userpage-img-title">
            <h4>{{ work.name}}</h4>
            <p v-if="work.tags && work.tags.tags && work.tags.tags.length" >
              <span class="badge  badge-success" v-for="(tag,tag_index) in work.tags.tags " :key="tag_index">{{ tag }}</span>
            </p>

          </div>
        </div></router-link>
      </div>

    </div>
    <div v-if="isfull==false && full_works.length-limited_works.length>0" class="text-center col-12">
      <button class="btn" @click="showAll()">Показать еще {{ full_works.length-limited_works.length }} </button>
    </div>
    <div v-if="isfull==true && full_works.length-limited_works.length>0" class="text-center col-12">
      <button class="btn" @click="hideAll()">Скрыть {{ full_works.length-limited_works.length }}</button>
    </div>

  </div>
</template>

<script>
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "PortfolioListUserPage",
  props: ["works","tags"],
  components: {
    VLazyImage
  },
  data(){
    return {
    "chunks_works":null,
    "full_works":[],
    "limited_works":[],
    'isfull':false,

    "active_tag":"all",
    }
  },
  methods:{
    openTag(tag){
      var app=this;
      app.chunks_works=[];
      app.isfull=false;
      app.active_tag=tag;
      app.recalcTag(tag);

    },
    showAll(){
      var app=this;
      app.isfull=true;
      app.recalcTag(app.active_tag);
    },
    hideAll(){
      var app=this;
      app.isfull=false;
      app.recalcTag(app.active_tag);
    },
    recalcTag(tag){
      var app=this;
      var current_works=app.works;
      var result_works=[];

      if(current_works.length>0){
        current_works.forEach(function(elem){
          var current_tags=elem.tags.tags;

          if(app.active_tag=="all" || current_tags.includes(tag)){
            result_works.push(elem);
          }
        })
      }
      app.full_works=result_works;
      if(app.isfull==false){
        app.limited_works=result_works.slice(0,6);
        result_works=app.limited_works;
      }else{
        app.limited_works=result_works.slice(0,6);
        result_works=app.full_works;
      }






      var SIZE=3;
      if(result_works.length>0) {
        const res        = result_works.reduce((p, c) => {
          if (p[p.length - 1].length == SIZE) {
            p.push([]);
          }

          p[p.length - 1].push(c);
          return p;
        }, [[]]);
        app.chunks_works = res;
      }else {
        app.chunks_works=[];
      }
    }
  },

  mounted(){
    var app=this;
    app.recalcTag("all");

  }
}
</script>

<style scoped>

</style>